<template>
  <div class="keywordPlanning">
    <el-row class="keywordHead">
      <keyword-head
        :content="websiteDetail"
        :customerId="customerId"
        :id="id"
        divisive="2"
      ></keyword-head>
    </el-row>
    <el-row class="keywordContent">
      <!-- 关键词列表 -->
      <el-col
        :span="12"
        class="keywordList"
      >
        <keyword-optimize
          :column="column1"
          :groups="groupsList"
          :isShowItem="false"
          :isShowBtn="false"
          :selection="false"
          :isShowHeader="true"
          :isFilter="false"
        ></keyword-optimize>
      </el-col>
      <!-- 文章列表 -->
      <el-col
        :span="12"
        class="keywordOptimize"
      >
        <seo-article
          ref="seoArticleRef"
          :column="column2"
          :groups="groupsOptimize"
          :isShowItem="false"
          :isShowBtn="false"
          :selection="false"
          :isShowHeader="false"
          :isFilter="false"
        ></seo-article>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import keywordList from "@/components/SEO/keywordList";
import keywordOptimize from "@/components/SEO/keywordOptimize";
import seoArticle from "@/components/SEO/seoArticle";
import keywordHead from "@/components/SEO/keywordHead";
import { articleStatus } from "@/common/dictionary";
import seo from "@/backend/services/seo/seoBoard.js";
import store from "@/backend/store/index";
export default {
  data() {
    const that = this;
    const column1 = [
      {
        label: "关键词",
        type: "articleAssistant",
        distinction: 'skip',
        bind: 'translateName',
        width: 250,
        searchkerword(keywordID, name, translateName) {
          that.$refs.seoArticleRef.keywordname = name + translateName ;
          that.$refs.seoArticleRef.keywordID = keywordID;
          that.$refs.seoArticleRef.query();
        }
      },
      {
        label: "昨日更新文章",
        align: "center",
        bind: "yesterdayArticleCount",
        sort: "yesterdayArticleCount",
        options: [
          {
            label: "由低到高",
            value: "asc"
          },
          {
            label: "由高到低",
            value: "desc"
          }
        ]
      },
      {
        label: "有效文章",
        align: "center",
        bind: "effectiveArticleCount",
        sort: "effectiveArticleCount",
        options: [
          {
            label: "由低到高",
            value: "asc"
          },
          {
            label: "由高到低",
            value: "desc"
          }
        ]
      },
      {
        label: "使用文章",
        align: "center",
        bind: "useArticleCount",
        sort: "useArticleCount",
        options: [
          {
            label: "由低到高",
            value: "asc"
          },
          {
            label: "由高到低",
            value: "desc"
          }
        ]
      }
    ];
    const column2 = [
      {
        label: "关键词",
        type: "articleAssistant",
        bind: 'useFlag',
        distinction: 'status',
        width: 60
      },
      {
        bind: "title",
        align: "center",
        width: 250
      },
      {
        bind: "createTimeStr",
        align: "center"
      },
      {
        label: "操作",
        type: "btnClick",
        style: "text",
        align: "center",
        bind: [
          {
            text: "查看",
            trigger: row => {
              that.$router.push({
                name: "articleDetail",
                query: {
                  articleId: row.articleId,
                  id: that.id
                }
              });
            }
          }
        ]
      }
    ];
    return {
      groupsList: {},
      groupsOptimize: {
        multiples: [
          {
            placeholder: "状态：全部",
            defaultText: "状态：全部",
            label: "状态：全部",
            options: articleStatus,
            prop: "useFlag",
            value: ""
          }
        ]
      },
      column1: column1,
      column2: column2,
      websiteDetail: "",
      id: "",
      keywordUrl: ""
    };
  },
  props: [],
  methods: {
    // 获取网站详情
    async getWebsiteDetail() {
      let res = await seo.getwebsitedetail(this.id);
      this.websiteDetail = res.data;
    }
  },
  components: { keywordList, keywordOptimize, keywordHead, seoArticle },
  created() {
    // 获取url参数
    this.id = this.$route.query.id;
    this.keywordUrl = this.$route.query.name;
    this.getWebsiteDetail();
  },
  computed: {
    // 客户Id
    customerId() {
      return store.getters.customerId;
    }
  },
  mounted() {
    this.groupsList = {
      others: [
        {
          tagName: "sky-input",
          placeholder: "关键词",
          label: "关键词",
          prop: "name",
          value: this.keywordUrl || ""
        }
      ]
    };
  }
};
</script>

<style scoped lang='scss'>
.keywordPlanning {
  background-color: #f1f4f9;
}
.keywordHead {
  width: 100%;
  font-size: 16px;
  color: #333;
  padding: 30px 20px 18px;
  background-color: #fff;
  margin-bottom: 10px;
}
.keywordContent {
  display: flex;
  justify-content: space-between;
  .keywordList,
  .keywordOptimize {
    flex: 1;
    background-color: #fff;
  }
  .keywordList {
    margin-right: 5px;
  }
  .keywordOptimize {
    margin-left: 5px;
  }
}
</style>
